/**
 * Warning: AI generated.
 * Generates a simple, stable numerical hash from a string.
 * Useful for deterministic mapping of strings (like IDs) to numerical ranges.
 * Based on a variation of the djb2 algorithm.
 *
 * @param str The input string.
 * @returns A 32-bit integer hash.
 */
export function simpleStringHash(str: string): number {
  let hash = 5381; // Initial seed
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    // hash * 33 + char
    hash = (hash << 5) + hash + char;
    hash |= 0; // Convert to 32bit integer
  }
  // Ensure the final result is also treated as a 32-bit integer
  // This helps ensure consistency across different JS engines potentially.
  return hash | 0;
}
